<mat-card class="card">
  <mat-card-content class="flex-container">
    @for (city of cities; track city) {
      <div class="city-chip" [class.notSelected]="!selectedCities.includes(city)" [style.background-color]="city.color" (click)="onCityClicked(city)">
        {{ city.displayName }}
      </div>
    }
    <button mat-icon-button class="save-button" (click)="saveSelectedCities()" matTooltip="Save your selected cities to the database" [disabled]="disableSaveButton" aria-label="Save your selected cities to the database">
      <mat-icon>save</mat-icon>
    </button>
  </mat-card-content>
</mat-card>
